import { render, staticRenderFns } from "./ProductAdditionalFields.vue?vue&type=template&id=54ace90c&scoped=true&lang=pug&"
import script from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdditionalFields.vue?vue&type=style&index=0&id=54ace90c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ace90c",
  null
  
)

export default component.exports